// extracted by mini-css-extract-plugin
export var container = "_dm-0";
export var content = "_dm-3";
export var customerTitle = "_dm-4";
export var empty = "_dm-5";
export var gray = "_dm-6";
export var header = "_dm-7";
export var info = "_dm-8";
export var loading = "_dm-2";
export var loadingCard = "_dm-9";
export var oneLine = "_dm-a";
export var personName = "_dm-e";
export var pillContainer = "_dm-b";
export var selected = "_dm-1";
export var text = "_dm-c";
export var twoLines = "_dm-d";
export var unread = "_dm-f";
export var unreadIndicator = "_dm-g";